import BookIndex from "components/shared/book/list";
import { DatetimeRange } from "components/shared/form";
import SharedReactTable from "components/shared/reactTable";
import { RecipientWithOrgOption, RecipientWithOrgValueContainer } from "components/shared/select";
import { dateTimeToView } from "helpers/date";
import { messageTypes } from "helpers/enums";
import { paths } from "helpers/paths";
import { NumericColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { getAllUsersForSelectList } from "sources/admin";

class NotificationQueueList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Наименование",
                accessor: "subject",
            },
            {
                Header: "Получатель",
                accessor: "recipient",
                id: "recipientId",
                sortable: false,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getAllUsersForSelectList,
                            inputProps: { name: "fullNameOrEmail" },
                            propName: "fullNameOrEmail",
                            components: {
                                Option: RecipientWithOrgOption,
                                ValueContainer: RecipientWithOrgValueContainer,
                            },
                        }}
                    />
                ),
                Cell: ({ value }) => value?.displayName || "",
            },
            {
                Header: "Тема Firebase",
                filterable: true,
                accessor: "topic",
            },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                filterable: false,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss (Z)"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss (Z)"),
            },
            {
                Header: "Дата отправки",
                accessor: "sentAt",
                filterable: false,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss (Z)"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss (Z)"),
            },
            {
                Header: "Настройка уведомления",
                accessor: "options",
                filterable: true,
                filterType: "enum",
            },
            {
                Header: "Тип уведомления",
                accessor: "type",
                filterType: "enum",
                filterable: true,
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "type" },
                            options: messageTypes,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(messageTypes, value),
            },
            {
                Header: "Количество попыток",
                accessor: "retryCount",
                filterType: "numeric",
                filterable: true,
                Filter: NumericColumnFilter,
            },
            {
                Header: "Статус",
                accessor: "isSuccessful",
                filterType: "nullableBoolean",
                filterable: true,
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "isSuccessful" },
                            options: [
                                { label: "Успешно", value: "true" },
                                { label: "Не успешно", value: "false" },
                                { label: "В обработке", value: "null" },
                            ],
                        }}
                    />
                ),
                Cell: ({ value }) => {
                    if (value) {
                        return <span className="badge badge-success">Успешно</span>;
                    } else if (value === false) {
                        return <span className="badge badge-danger">Не успешно</span>;
                    } else {
                        return <span className="badge badge-warning">В обработке</span>;
                    }
                },
            },
        ];
    }

    renderActions = () => {
        return <DatetimeRange name="sentAt" {...this.props} />;
    };

    renderListComponent = () => {
        const tableProps = {
            rowCname: "row--clickable",
            onRowClick: (row) => this.props.history.push(paths.notificationQueueShow(row.original.id)),
        };
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} isLazy tableProps={tableProps} />;
    };
}

export default tableContainer(NotificationQueueList, "notification-queues");
